<template>
    <section class="hero">
            <div class="hero-body">
                <div class="is-6-desktop is-pulled-right hero-col-bg">
                    <div class="hero-content">
                        <p class="is-uppercase">Jetzt durchstarten mit dem neuen</p>
                        <h1 class="title">Autostrom-Rechner
                        </h1>
                        <h2 class="subtitle is-4">Einfach</h2>
                        <p>Unkomplizierte Einbindung unseres Moduls in Ihre Website</p>
                        <h2 class="subtitle is-4">Schnell</h2>
                        <p>Mit 5 Klicks Kosten und CO<sub>2</sub>-Bilanz auf einen Blick</p>
                        <h2 class="subtitle is-4">Aktuell</h2>
                        <p>Wir liefern die E-Modelle und Sie Ihre Tarifdaten</p>
                        <a class="button is-link" href="#downcalculator">Elektrisiert?</a>
                    </div>
                </div>
            </div>
    </section>
</template>

<script>
    export default {
        name: "Hero"
    }
</script>

<style lang="scss" scoped>

</style>